import * as tslib_1 from "tslib";
import { of, forkJoin } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { PruHttpService } from '../../../../services/pru-http.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../services/pru-http.service";
var AccountsBalanceService = /** @class */ (function () {
    function AccountsBalanceService(pruHttpService) {
        this.pruHttpService = pruHttpService;
        this.defaultApiUrl = '/api/secure/direct-account/v2/acctservice/accounts/{referenceId}/account-values';
        this.balanceTypeMapping = {
            sia: 'fullnetworth',
            unknown: 'unknown'
        };
    }
    AccountsBalanceService.prototype.getAccountsBalance = function (productType, referenceIds) {
        var _this = this;
        var e_1, _a;
        if (!productType || !referenceIds || referenceIds.length === 0) {
            return of([]);
        }
        var accountBalanceObservableList = [];
        try {
            for (var referenceIds_1 = tslib_1.__values(referenceIds), referenceIds_1_1 = referenceIds_1.next(); !referenceIds_1_1.done; referenceIds_1_1 = referenceIds_1.next()) {
                var referenceId = referenceIds_1_1.value;
                accountBalanceObservableList.push(this.getAccountBalanceByReference(referenceId));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (referenceIds_1_1 && !referenceIds_1_1.done && (_a = referenceIds_1.return)) _a.call(referenceIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return forkJoin(accountBalanceObservableList)
            .pipe(switchMap(function (accountBalanceInfos) {
            return of(_this.prepareAccountBalanceInfo(accountBalanceInfos, productType));
        }));
    };
    AccountsBalanceService.prototype.getAccountBalanceByReference = function (referenceId) {
        return this.pruHttpService.get(this.getApiUrl(referenceId), 'AccountsBalanceService').pipe(catchError(function () { return of(null); }));
    };
    AccountsBalanceService.prototype.getApiUrl = function (referenceId) {
        return this.defaultApiUrl.replace('{referenceId}', referenceId);
    };
    AccountsBalanceService.prototype.prepareAccountBalanceInfo = function (balanceInfos, productType) {
        var _this = this;
        if (!balanceInfos || balanceInfos.length === 0) {
            return balanceInfos;
        }
        balanceInfos = balanceInfos.map(function (balanceInfo) {
            if (!balanceInfo || !balanceInfo.accountValues) {
                return null;
            }
            var balanceAndDate = _this.getBalanceAndDate(productType, balanceInfo.accountValues);
            if (!balanceAndDate) {
                return null;
            }
            return {
                productType: productType,
                referenceId: balanceInfo.referenceId,
                accountValue: balanceAndDate ? balanceAndDate.accountValue : 0,
                asOfDate: balanceAndDate ? balanceAndDate.asOfDate : ''
            };
        });
        return balanceInfos.filter(function (item) { return !!item; });
    };
    AccountsBalanceService.prototype.getBalanceAndDate = function (productType, accountValues) {
        var balanceType = this.balanceTypeMapping[productType.toLowerCase()] || this.balanceTypeMapping.unknown;
        var foundAccountValues = accountValues.filter(function (accountValue) {
            return accountValue && accountValue.type && accountValue.type.toLowerCase() === balanceType;
        });
        if (foundAccountValues && foundAccountValues.length > 0) {
            return {
                accountValue: foundAccountValues[0].amount,
                asOfDate: this.formatAsOfDate(foundAccountValues[0].asOfDate)
            };
        }
        else {
            return null;
        }
    };
    // will come back to as format not stable yet. - KM
    AccountsBalanceService.prototype.formatAsOfDate = function (rawDate) {
        try {
            if (rawDate.indexOf('-') > 0) {
                var splits = void 0;
                if (rawDate.indexOf('T') > 0) {
                    splits = rawDate.split('T')[0].split('-');
                }
                else {
                    splits = rawDate.split(' ')[0].split('-');
                }
                return splits[1] + '/' + splits[2] + '/' + splits[0];
            }
            return rawDate;
        }
        catch (e) {
            return rawDate;
        }
    };
    AccountsBalanceService.ngInjectableDef = i0.defineInjectable({ factory: function AccountsBalanceService_Factory() { return new AccountsBalanceService(i0.inject(i1.PruHttpService)); }, token: AccountsBalanceService, providedIn: "root" });
    return AccountsBalanceService;
}());
export { AccountsBalanceService };
